import ProfileRepository from '@/repositories/ProfileRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'
import { IProfileSeed } from '@/entities/Profile'
import { ErrorType, ConflictError } from '@/common/errors'

export interface ISignupGroupMemberUseCaseParams {
  profileRepository: ProfileRepository
  snapsnapGateway: SnapsnapGateway
}

export default class SignupGroupMemberUseCase implements BaseUseCase {
  profileRepository: ProfileRepository
  snapsnapGateway: SnapsnapGateway

  constructor({ profileRepository, snapsnapGateway }: ISignupGroupMemberUseCaseParams) {
    this.profileRepository = profileRepository
    this.snapsnapGateway = snapsnapGateway
  }

  async execute(params: { token: string; seed: IProfileSeed }) {
    try {
      const profile = await this.snapsnapGateway.GroupMember.signupGroupMember(params)
      this.profileRepository.saveProfile(profile)
    } catch (error) {
      if (error.status === ErrorType.CONFLICT) {
        throw new ConflictError(error.message)
      } else {
        throw error
      }
    }
  }
}
